







































import { Component, Ref, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import TokenChooserItem from '@/components/tokens/TokenChooserItem.vue'
import { Token } from '@/config/constants/dex'
import TokensUtil from '@/utils/TokensUtil'
import { ethers } from 'ethers'

const accountsStore = namespace('accounts')

@Component({
	components: {
		TokenChooserItem,
	},
})
export default class TokenChooserDialog extends Vue {
	tokens: Array<Token> = []
	allTokens: Array<Token> = []
	search = ''
	loading = true

	@accountsStore.State('activeAccount')
	user!: string

	@accountsStore.Getter('providerEthers')
	provider!: ethers.providers.JsonRpcProvider | null

	@Ref('dialog')
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	private dialog: any

	@Ref('tokensList')
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	private tokensList: any

	show() {
		this.dialog.show()
	}

	hide() {
		this.dialog.hide()
	}

	onDialogHide() {
		// required to be emitted
		// when QDialog emits "hide" event
		this.$emit('hide')
	}

	onCancelClick() {
		this.hide()
	}

	async loadTokens(index: number, done: () => void) {
		if (!this.search) {
			this.tokens = this.allTokens.slice(0, index * 10)
		} else {
			const filteredTokens = await TokensUtil.filterTokens(this.search)
			this.tokens = filteredTokens.slice(0, Math.min(index * 10, filteredTokens.length))
		}
		if (this.tokens.length > 0 && this.tokens.length <= 10) {
			this.tokensList.stop()
		}
		done()
	}

	async filterTokens() {
		this.tokens = []
		this.tokensList.reset()
		this.tokensList.resume()
		this.tokensList.poll()
	}

	onTokenChosen(token: Token) {
		const aToken: Token = {
			name: token.name,
			symbol: token.symbol,
			address: token.address,
			decimals: token.decimals,
			logoURI: token.logoURI,
			chainId: token.chainId,
		}
		this.$emit('ok', aToken)
		// this.$emit('ok', token)
		this.hide()
	}

	async onProviderChange() {
		this.loading = true
		this.allTokens = await TokensUtil.getAllTokens()
		this.tokens = []
		this.loading = false
	}

	async mounted() {
		await this.onProviderChange()
		document.addEventListener('web3-connection', this.onProviderChange)
	}

	unmounted() {
		document.removeEventListener('web3-connection', this.onProviderChange)
	}
}
